
<div style="padding:20px;">
  
  <div style="margin-bottom:10px;">
    This tab shows Propers for all Lectionary Years and Liturgy Types defined in the Service Mappings. 
    Click any of link(s) below to preview the available Propers. 
  </div>

  
  <div *ngIf="entities != null">
    
    <div *ngFor="let m of entities" class="simpleRow">
    
      <div><a [href]="getHtmlUrl(m)" target="preview">{{m.Title}}</a></div> 
      
    </div>

    <div *ngIf="entities.length == 0" class="text-center">
        There are no entries
    </div> 

</div>

</div>